import axios from 'axios'

export default cep => {
    return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        .then(res => {
            if (!res.data.erro) 
                return { 
                    district: res.data.bairro,
                    zipcode: res.data.cep,
                    city: res.data.localidade,
                    address: res.data.logradouro,
                    stateCode: res.data.uf,
                }
        })
        .catch(err => { throw err })
}



// WEBPACK FOOTER //
// ./src/services/address.js